import { createSelector } from 'reselect';

import getConfig from './getConfig';

export default createSelector([getConfig], config =>
  config.copyrightText
);